import { Pipe, PipeTransform } from '@angular/core';
import { FormatData } from '@classes/format-data';

@Pipe({
  name: 'displayInvoice',
})
export class DisplayInvoicePipe implements PipeTransform {
  transform(value: unknown): string {
    return FormatData.displayInvoiceNumber(value as string);
  }
}
